import axios from './vue-axios/axios'

const prepareUserEntity = userEntity => {
  let user_entity = {
    entity_id: userEntity.entity.id,
    resource_type: userEntity.resource_type,
    service_ids: userEntity.services.map(service => service.id),
    occupation_ids: userEntity.occupations.map(occupation => occupation.id),
  }

  if (userEntity.affiliated_service !== null) {
    user_entity.affiliated_service_id = userEntity.affiliated_service.id
  }

  return user_entity
}

export function confirmUserEntities(userEntities){
  return axios.put('/v1/user_entities/confirm', {
    user_entities: userEntities.map(userEntity => prepareUserEntity(userEntity))
  });
}

export function declineUserEntity(entityId){
  return axios.delete(`/v1/user_entities/${entityId}/decline`);
}

export function createUserEntities(userEntities) {
  return axios.post('/v1/user_entities/', {
    user_entities: userEntities.map(userEntity => prepareUserEntity(userEntity))
  });
}



// WEBPACK FOOTER //
// ./src/backend/userEntities.js